import { render, staticRenderFns } from "./BannerSwitchTab.vue?vue&type=template&id=3f975867&scoped=true"
import script from "./BannerSwitchTab.vue?vue&type=script&lang=js"
export * from "./BannerSwitchTab.vue?vue&type=script&lang=js"
import style0 from "./BannerSwitchTab.vue?vue&type=style&index=0&id=3f975867&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f975867",
  null
  
)

export default component.exports